import { Action, createAction, props } from '@ngrx/store';

import { ScannedCode, ScannedCodeWithEntity } from 'app/features/scan-flow/models';
import { ProductBoxRegistration } from 'app/shared/components/product-box/models';
import { Activity } from 'app/shared/features/activity-selector/models';
import { RowSelectionItem } from 'app/shared/features/map-row-selector/models';
import { ScanFlowRegistrationData } from 'app/state/scan-flow/scan-flow.reducer';

export const initScanFlow = createAction('[ScanFlow] Initialize');

export const initScanFlowSuccess = createAction('[ScanFlow] Initialization Success');

export const scanNewCodeForFlow = createAction('[ScanFlow] Scan New Code');

export const syncScannedCodeFromStore = createAction(
    '[ScanFlow] Sync Code From Store',
    props<{ token: string }>(),
);

export const applyScanFlowRegistrationDataFromStorage = createAction(
    '[ScanFlow] Apply Registration Data From Storage',
    props<{
        registrationDataFromStorage: ScanFlowRegistrationData | undefined;
    }>(),
);

export const processScannedTextInScanFlow = createAction(
    '[ScanFlow] Process Scanned Text',
    props<{ scannedText: string }>(),
);

export const resetScanFlowRegistrationData = createAction('[ScanFlow] Set Registration Data');

export const resetPartialScanFlowRegistrationData = createAction('[ScanFlow] Set Partial Registration Data');

export const addScanFlowCode = createAction(
    '[ScanFlow] Add Scanned Code',
    props<{ scannedCode: ScannedCode }>(),
);

export const setScanFlowEmployeeNumber = createAction(
    '[ScanFlow] Set Employee Number',
    props<{ employeeNumber: number }>(),
);

export const changeScanFlowRowSelection = createAction(
    '[ScanFlow] Change Row Selection',
    props<RowSelectionItem>(),
);

export const setActivityInScanFlow = createAction(
    '[ScanFlow] Set Activity In Flow',
    props<{
        activityCode: ScannedCodeWithEntity<Activity> | undefined;
        keepRegistrationData: boolean;
        isContainerMeasurement?: boolean;
        batchCode?: ScannedCode;
    }>(),
);

export const setBatchInScanFlow = createAction(
    '[ScanFlow] Set Batch In Flow',
    props<{
        batchCode: ScannedCode;
        keepRegistrationData: boolean;
        isContainerMeasurement?: boolean;
    }>(),
);

export const removeScannedCodeFromFlow = createAction(
    '[ScanFlow] Remove Scanned Code',
    props<{ code: string }>(),
);

export const scheduleScanFlowRegistration = createAction(
    '[ScanFlow] Schedule Registration',
    props<{ scheduledRegistrationDate: number | undefined }>(),
);

export const cancelScheduledScanFlowRegistration = createAction('[ScanFlow] Cancel Scheduled Registration');

export const sendCurrentScanFlowRegistrationData = createAction(
    '[ScanFlow] Send Current Registration Data',
    props<{
        registrationTimestamp: number;
    }>(),
);

export const sendCurrentScanFlowContainerMeasurementData = createAction(
    '[ScanFlow] Send Current Container Measurement Data',
    props<{
        registrationTimestamp: number;
    }>(),
);

export const showNotificationScanFlowInProgressRegistrationDataSent = createAction(
    '[ScanFlow] Show Notification In-progress Registration Data Sent',
);

export const sendTransformedScanFlowRegistrationData = createAction(
    '[ScanFlow] Send Transformed Registration Data',
    props<{
        onSuccessAction: Action | undefined;
        registrationData: ScanFlowRegistrationData;
        registrationTimestamp: number;
    }>(),
);

export const sendTransformedScanFlowRegistrationDataSuccess = createAction(
    '[ScanFlow] Send Transformed Registration Data Success',
    props<{ registrationData: ScanFlowRegistrationData }>(),
);

export const sendTransformedScanFlowContainerMeasurementData = createAction(
    '[ScanFlow] Send Transformed Container Measurement Data',
    props<{
        onSuccessAction: Action | undefined;
        registrationData: ScanFlowRegistrationData;
        registrationTimestamp: number;
    }>(),
);

export const sendTransformedScanFlowContainerMeasurementDataSuccess = createAction(
    '[ScanFlow] Send Transformed Container Measurement Data Success',
    props<{ registrationData: ScanFlowRegistrationData }>(),
);

export const userInputForScanFlowStarted = createAction('[ScanFlow] User Input Started');

export const userInputForScanFlowEnded = createAction('[ScanFlow] User Input Ended');

export const updateScanFlowRegistrationDataInStorage = createAction(
    '[ScanFlow] Update Scan Flow Registration Data In Storage',
    props<ScanFlowRegistrationData>(),
);

export const endWorkScanFlow = createAction('[ScanFlow] End Work', props<{ endWorkTimestamp: number }>());

export const setScanFlowAmountResult = createAction(
    '[ScanFlow] Set Amount Result',
    props<{ amountResult: number | undefined }>(),
);

export const setScanFlowProductBoxRegistrations = createAction(
    '[ScanFlow] Set Product Box Registrations',
    props<{ updatedProductBoxRegistrations: ProductBoxRegistration[] }>(),
);
